import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  taskBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignContent: "flex-start",
    backgroundColor: "white",
    marginTop: theme.spacing(1),
    borderStyle: "solid",
    borderColor: theme.palette.primary.main,
    borderWidth: "medium",
  },
  checkbox: {
    height: "2em",
    width: "2em",
    border: "solid black",
    borderWidth: "thin",
    margin: theme.spacing(1),
    cursor: "pointer",
    "&:hover": {
      boxShadow: "0 5px 15px #D5E2D5",
    },
  },
  edit: {
    height: "1.5rem",
    width: "1.5rem",
    color: "#828282",
  },
  taskDetails: {
    flexGrow: 4,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  taskTitle: {
    fontSize: 18,
    color: theme.palette.primary.dark,
  },
  taskDescription: {
    fontSize: 14,
    color: "#828282",
  },
}));

export default useStyles;
